import { react2angular } from 'react2angular';
import SendListingEditor from './SendListingEditor';

import template from './messaging_blast.html';

angular.module('bb.messaging').component('bbListingSend', {
  controller: ListingSendController,
  controllerAs: 'vm',
  template,
});

ListingSendController.$inject = [
  '$scope',
  '$resource',
  '$routeParams',
  '$rootScope',
  '$window',
];
// This component shares the same template with messenging_blast.controller;
// TODO: Remove $scope and $resource once messenging_blast is converted to component as well;
function ListingSendController(
  $scope,
  $resource,
  $routeParams,
  $rootScope,
  $window,
) {
  const vm = this;

  const Message = $resource('/listing/send');
  const Listing = $resource('/listing/ids');
  vm.$onInit = () => {
    vm.auth = $rootScope.auth;
    // TODO: Move the defazult template logic to backend;
    const { location, address } = $rootScope.auth;

    const subBrokerage = $rootScope.auth.org.addresses[location][address];
    const subBrokerageName = subBrokerage ? subBrokerage.name : '';

    const signature = `<br><br>
      <p>${$rootScope.auth.firstName} ${$rootScope.auth.lastName}<br>
      ${$rootScope.auth.email}<br>
      ${subBrokerageName || $rootScope.auth.org.mls_name}</p>`;

    $scope.pageTitle = 'Send Message';
    $scope.message = {
      emails: '',
      body: signature,
    };

    $scope.setBody = value => {
      $scope.message.body = value;
      $scope.$apply();
    };

    Listing.query({ lids: $routeParams.lids }).$promise.then(data => {
      $scope.listings = data;
      $scope.dataLoaded = true;
    });

    $scope.remove = index => {
      $scope.listings.splice(index, 1);
    };

    $scope.send = messageForm => {
      messageForm.$submitted = true;

      if (!messageForm.$valid) {
        $window.scrollTo(0, 0);
      } else {
        $scope.dataLoaded = false;
        $scope.message.listings = $scope.listings.map(listing => listing.id);

        Message.save(
          $scope.message,
          () => {
            $scope.dataLoaded = true;
            swal(
              {
                title: 'Message Sent',
                html: true,
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: '#62cb31',
                confirmButtonText: 'Close',
                closeOnConfirm: true,
              },
              () => {
                $window.location.replace('/#/listing/list/brokerage/0');
              },
            );
          },
          err => {
            $scope.dataLoaded = true;
            swal(
              {
                title: `Error: ${err.message ?? err.status ?? 'Server error'}`,
                html: true,
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#62cb31',
                confirmButtonText: 'Close',
                closeOnConfirm: true,
              },
              () => {
                $window.location.replace('/#/listing/list/brokerage/0');
              },
            );
          },
        );
      }
    };
  };
}

angular
  .module('bb.messaging')
  .component(
    'sendListingEditor',
    react2angular(SendListingEditor, ['body', 'setBody']),
  );
